import chalk from 'chalk'

/**
 * Render markdown-ish text to chalk-styled terminal output.
 * Handles: bold, italic, inline code, code blocks, headers, lists, links, blockquotes.
 */
export function renderMarkdown(text: string): string {
  const lines = text.split('\n')
  const result: string[] = []
  let inCodeBlock = false

  for (const line of lines) {
    if (line.startsWith('```')) {
      inCodeBlock = !inCodeBlock
      if (inCodeBlock) {
        result.push(chalk.dim('  │'))
      }
      continue
    }

    if (inCodeBlock) {
      result.push(chalk.dim('  │ ') + chalk.dim(line))
      continue
    }

    let rendered = line

    // Headers
    if (rendered.startsWith('### ')) {
      result.push(chalk.bold(rendered.slice(4)))
      continue
    }
    if (rendered.startsWith('## ')) {
      result.push(chalk.bold.underline(rendered.slice(3)))
      continue
    }
    if (rendered.startsWith('# ')) {
      result.push(chalk.bold.underline(rendered.slice(2)))
      continue
    }

    // Blockquotes
    if (rendered.startsWith('> ')) {
      result.push(chalk.dim('│ ') + chalk.dim(rendered.slice(2)))
      continue
    }

    // List items
    if (/^\s*[-*] /.test(rendered)) {
      rendered = rendered.replace(/^(\s*)[-*] /, '$1· ')
    }

    // Inline formatting (order matters: code first to avoid bold/italic inside code)
    rendered = rendered.replace(/`([^`]+)`/g, (_, code) => chalk.cyan(code))
    rendered = rendered.replace(/\*\*([^*]+)\*\*/g, (_, bold) => chalk.bold(bold))
    rendered = rendered.replace(/\*([^*]+)\*/g, (_, italic) => chalk.italic(italic))
    rendered = rendered.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_, text, url) =>
      chalk.underline(text) + chalk.dim(` (${url})`),
    )

    result.push(rendered)
  }

  return result.join('\n')
}
